import { render, staticRenderFns } from "./CertificateDetails.vue?vue&type=template&id=5661e85a&scoped=true"
import script from "./CertificateDetails.vue?vue&type=script&lang=js"
export * from "./CertificateDetails.vue?vue&type=script&lang=js"
import style0 from "./CertificateDetails.vue?vue&type=style&index=0&id=5661e85a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5661e85a",
  null
  
)

export default component.exports